import { useState } from "react"
import { createPortal } from "react-dom"
import { FaArrowLeft, FaArrowRight, FaDownload } from "react-icons/fa"
import styled from "styled-components"
import { IconButtonWrapper, Modal } from "@prosolve/common-components-ui"
import { downloadUrls } from "../../utils"

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: 15px;
  min-width: 480px;
  min-height: 340px;
  background: ${({ $props }) => ($props.isDark ? '#161616' : '')};
`

const Image = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;

  & > img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`

const Actions = styled.div`
  display: flex;
  position: absolute;
  top: -30px;
  left: 10px;
  gap: 5px;
  align-items: center;
`

const Download = styled.div`
  cursor: pointer;

  & svg {
    color: ${({ $props }) => ($props.isDark ? 'white' : '')};
  }
`

const Nav = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  overflow: visible;
  z-index: 110000;
`

const NavStyle = styled.div`
  position: absolute;
  font-size: 64px;
  top: -40px;

  & svg {
    color: ${({ $props }) => ($props.isDark ? 'white' : '')};
  }
`

const NavLeft = styled(NavStyle)`
  left: -35vw;
`

const NavRight = styled(NavStyle)`
  right: -35vw;
`

export const ImageLightbox = ({
  images,
  initialIndex,
  isDark = true,
  isHideDownload,
  onClose
}) => {
  const [imageIndex, setImageIndex] = useState(initialIndex || 0)
  const [image, setImage] = useState(images?.[imageIndex])

  const {
    src,
    alt
  } = image || {}
  
  const props = { isDark }
  const showNav = images?.length > 1

  const changeImageIndex = (index) => {
    const newImage = images?.[index]
    if (newImage) {
      setImageIndex(index)
      setImage(newImage)
    } 
  }

  const onClickNav = (direction) => {
    changeImageIndex(imageIndex + direction)
  }

  const onClickDownload = () => {
    downloadUrls([src])
  }

  return (
    <Modal onClose={onClose} isAutoWidth={true} isAutoHeight={true} absoluteHeader={true} isDark={isDark} closeOnOffClick={true}>
      <Container $props={props}>

        <Actions>
          {!isHideDownload &&
            <Download $props={props} onClick={onClickDownload}>
              <IconButtonWrapper $isDark={isDark}>
                <FaDownload title='Download' />
              </IconButtonWrapper>
            </Download>
          }
        </Actions>

        {showNav && createPortal(
          <Nav>
            <NavLeft $props={props} onClick={() => onClickNav(-1)}>
              <IconButtonWrapper $isDark={isDark}>
                <FaArrowLeft title='Previous' />
              </IconButtonWrapper>
            </NavLeft>
            <NavRight $props={props} onClick={() => onClickNav(1)}>
              <IconButtonWrapper $isDark={isDark}>
                <FaArrowRight title='Next' />
              </IconButtonWrapper>
            </NavRight>
          </Nav>
        , document.body)}

        <Image>
          <img src={src} alt={alt || src} />
        </Image>

      </Container>
    </Modal>
  )
}